import { useTheme } from '@mui/material/styles';

const TERTIARY = { light: '#3e5c8a', dark: '#9bb0d9' };

export interface PortalCategoryColors {
  overview: string;
  inventory: string;
  grn: string;
  dispatch: string;
  invoices: string;
}

/** Client Portal counterpart to the internal dashboard's useCategoryColors — same idea (one
 * on-brand color per category tab, resolved off the active theme), smaller palette since the
 * portal only has 5 tabs instead of 9. */
export function usePortalCategoryColors(): PortalCategoryColors {
  const theme = useTheme();
  const p = theme.palette;

  return {
    overview: p.primary.main,
    inventory: p.info.main,
    grn: theme.palette.mode === 'dark' ? TERTIARY.dark : TERTIARY.light,
    dispatch: p.success.main,
    invoices: theme.palette.mode === 'dark' ? p.warning.light : p.warning.dark,
  };
}
